// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__S8J0H","form":"styles_form__2mNQu"};